
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from "react-router";

import { RootState } from '../../store';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { SearchTextField } from "../../components/SearchTextField";

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarTipoPersona, AgregarTipoPersona, TipoPersona } from "../../connections/catalogos/TipoPersonaConnection";

import { TipoPersonaProps } from "../../interfaces/catalogos/TipoPersonaInterface";

export const TipoPersonaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador } = useSelector( ( state: RootState ) => state.auth );

    const [TipoPersonaArray, setTipoPersonaArray] = useState<TipoPersonaProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idTipoPersona, setIdTipoPersona] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoPersonaArray, ( item, filtro ) => item.descripcion.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const TipoPersonaSelected = TipoPersonaArray.find( ( elem ) => elem.idTipoPersona === id );

        if( TipoPersonaSelected ){

            await ActualizarTipoPersona({ ...TipoPersonaSelected, activo: checked }).then( resp => {
                
                if( resp.idTipoPersona ){

                    var newArray = TipoPersonaArray.map( ( elem ) => {

                    if( elem.idTipoPersona === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setTipoPersonaArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 
                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idTipoPersona !== 0 ){

            const TipoPersonaSelected = TipoPersonaArray.find( ( elem ) => elem.idTipoPersona === idTipoPersona );

            if( TipoPersonaSelected ){

                setLoading( true );
    
                await ActualizarTipoPersona({ ...TipoPersonaSelected, descripcion, }).then( resp => {
                    
                    if( resp.idTipoPersona ){

                        setTimeout(() => {
                            
                            var newArray = TipoPersonaArray.map( ( elem ) => {
        
                                if( elem.idTipoPersona === idTipoPersona ){
                                    elem.descripcion = descripcion;
                                }
                        
                                return elem;
                            });
                    
                            setTipoPersonaArray( newArray );
                            setOpenModal( false );
                            setLoading( false );
                            
                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' })); 

                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const TipoPersonaAdd: TipoPersonaProps = {
                idTipoPersona: 0,
                descripcion,               
                activo: true,
            }

            setLoading( true );

            await AgregarTipoPersona( TipoPersonaAdd ).then( resp => {
                    
                if( resp.idTipoPersona ){                
            
                    setTimeout(() => {
                        
                        setTipoPersonaArray([ ...TipoPersonaArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de persona correctamente', variant: 'success' })); 

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setTipoPersonaArray( [] );

            await TipoPersona().then( resp => {

                setTimeout(() => {
                    
                    setTipoPersonaArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de persona' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >

                <Grid size={{ xs: 6 }} textAlign={'start'}>
                    {
                        administrador
                        &&
                            <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }
                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>
                    <Button
                        variant="contained"
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdTipoPersona( 0 );
                            setDescripcion( '' );

                            setOpenModal( true );
                        }}
                    >
                        Agregar
                    </Button>
                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }} textAlign={'start'}>
                    <SearchTextField
                        value={ filtro }
                        label="Buscar tipo de persona"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />
                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    dataFiltrada
                            )
                            .map( ( { idTipoPersona, descripcion, activo } ) => (

                                <TableRow key={ idTipoPersona} >
                                
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        { idTipoPersona }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      
    
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idTipoPersona ) }
                                        />
                                       
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdTipoPersona( idTipoPersona );
                                                    setDescripcion( descripcion );

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  
                                        
                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={1} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { dataFiltrada.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>
            
                <DialogContent sx={DialogContentStyle }>
                       
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción'}
                        variant="outlined"                           
                        multiline
                        rows={4}                                        
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }} 
                    /> 

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => { setOpenModal( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}